//#region types
import { WintSuperkollAPIModelWintSalaryReport } from "wint-api-client/dist/types";
import { SelectionItem } from "models/utilTypes/selectionTypes";
//#endregion
import { EnumHelper, LocalizationHelperInstance } from "utils/helpers";

function useSalaryStateHelper() {
  const getWintSalaryStateText = (state: WintSuperkollAPIModelWintSalaryReport.WintSalaryState) => {
    return LocalizationHelperInstance.getFormattedMessage(`Salary.WintSalaryState_${state}`);
  };

  const getSalaryPaymentStateText = (state: WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState) => {
    return LocalizationHelperInstance.getFormattedMessage(`Salary.SalaryPaymentState_${state}`);
  };

  const getSalaryStateSelectionItems = (): SelectionItem[] => {
    return EnumHelper.getNumericItemValues(WintSuperkollAPIModelWintSalaryReport.WintSalaryState).map((state) => ({
      id: state,
      value: LocalizationHelperInstance.getTranslatedEnumValue("Salary.WintSalaryState", state),
    }));
  };

  const getSalaryPaymentStateSelectionItems = (): SelectionItem[] => {
    return EnumHelper.getNumericItemValues(WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState).map((state) => ({
      id: state,
      value: LocalizationHelperInstance.getTranslatedEnumValue("Salary.SalaryPaymentState", state),
    }));
  };

  return {
    getWintSalaryStateText,
    getSalaryPaymentStateText,
    getSalaryStateSelectionItems,
    getSalaryPaymentStateSelectionItems,
  };
}

export default useSalaryStateHelper;
